'use strict';

const PatientDetailsCtrl = function ($rootScope, $state) {
    var ctrl = this;

    if ($state.is('main.patients.list.details.treatsteps')){
      ctrl.selectedTab = 3;
    }

    $rootScope.$on('emil:patientsListChanged', function(){
      // reset data
      ctrl.patient = undefined;
    });
};

PatientDetailsCtrl.$inject = ['$rootScope', '$state'];

module.exports = {
  template: require('./patients-details.html'),
  require: {
    parent: '^patientList'
  },
  bindings: {
    patient: '<'
  },
  controller: PatientDetailsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/patient-details/patients-details.component.js